import React from "react";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase";
import CreateCompanyAccounts from "./CreateCompanyAccounts";
import SystemAdminSidebar from "./Sidebar";

export default function SystemAdminHome() {
  const navigate = useNavigate();
  const user = auth.currentUser;

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("[SystemAdmin] 登出失敗：", error);
    }
  };

  return (
    <div style={styles.page}>
      <SystemAdminSidebar activeKey="companyAccounts" />

      <div style={styles.workspace}>
        <header style={styles.topbar}>
          <div style={styles.heading}>
            <strong style={styles.headingTitle}>系統管理</strong>
            <span style={styles.headingSubtitle}>公司帳號</span>
          </div>

          <div style={styles.accountArea}>
            <button type="button" onClick={handleLogout} style={styles.logoutButton}>
              登出
            </button>
          </div>
        </header>

        <main className="system-admin-content" style={styles.content}>
          <CreateCompanyAccounts user={user} account={null} />
        </main>
      </div>

      <style>{`
        .system-admin-content .dmca-root {
          height: 100% !important;
          max-height: 100% !important;
          min-height: 0 !important;
        }
      `}</style>
    </div>
  );
}

const styles = {
  page: {
    width: "100%",
    height: "100vh",
    minWidth: 0,
    minHeight: 0,
    display: "flex",
    overflow: "hidden",
    background: "#F3F4F8",
    color: "#111827",
    fontFamily: 'Inter, "Noto Sans TC", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  workspace: {
    flex: "1 1 auto",
    minWidth: 0,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  topbar: {
    height: 78,
    flex: "0 0 78px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 20,
    padding: "0 26px",
    borderBottom: "1px solid rgba(15,23,42,0.08)",
    background: "rgba(255,255,255,0.96)",
    boxSizing: "border-box",
  },
  heading: {
    minWidth: 0,
    display: "flex",
    alignItems: "baseline",
    gap: 14,
  },
  headingTitle: {
    color: "#111827",
    fontSize: 17,
    fontWeight: 850,
  },
  headingSubtitle: {
    color: "#7B8490",
    fontSize: 13,
    fontWeight: 700,
  },
  accountArea: {
    display: "flex",
    alignItems: "center",
    gap: 14,
  },
  accountName: {
    maxWidth: 260,
    overflow: "hidden",
    color: "#6B7280",
    fontSize: 13,
    fontWeight: 700,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  logoutButton: {
    minHeight: 38,
    padding: "0 14px",
    border: "1px solid rgba(15,23,42,0.12)",
    borderRadius: 11,
    background: "#FFFFFF",
    color: "#374151",
    fontFamily: "inherit",
    fontSize: 13,
    fontWeight: 750,
    cursor: "pointer",
  },
  content: {
    flex: "1 1 auto",
    minWidth: 0,
    minHeight: 0,
    overflow: "hidden",
  },
};
